import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const SoundwaveIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M13 19H11V4.92H13V19ZM7.4 14.3H5.28V9.62H7.4V14.3ZM18.72 14.3H16.6V9.62H18.72V14.3Z" />
    </SvgIcon>
  );
});
